import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalCard from "./modal-card";
import { Quest } from "@/types/quests";
import { QUEST_RARITY_POPUP_LABELS } from "@/constants/quests";

interface NewQuestPopupProps {
  quest: Quest;
  onClose: (dontShowAgain?: boolean) => void;
}

export default function NewQuestPopup({ quest, onClose }: NewQuestPopupProps) {
  const navigate = useNavigate();
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const rarityLabel =
    QUEST_RARITY_POPUP_LABELS[String(quest.rarity_label)] ||
    QUEST_RARITY_POPUP_LABELS["1"];

  const handleShow = () => {
    onClose(dontShowAgain);
    navigate("/quests");
  };

  const handleClose = () => {
    onClose(dontShowAgain);
  };

  return (
    <ModalCard
      title={rarityLabel}
      onClose={handleClose}
      headerColor="blue"
    >
      <main className="flex flex-col gap-4 px-5 pb-6 pt-4">
        <div className="flex flex-col gap-2">
          <h3 className="text-[20px] font-semibold uppercase text-white">
            {quest.title}
          </h3>
          <p className="text-[16px] text-gray-300 leading-relaxed">
            {quest.description}
          </p>
        </div>
        <button
          onClick={handleShow}
          className="w-full py-3 px-4 bg-[#0099FE] text-white text-[18px] font-semibold uppercase hover:opacity-90 transition-opacity"
        >
          Show
        </button>
        <label className="flex items-center gap-2 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={dontShowAgain}
            onChange={e => setDontShowAgain(e.target.checked)}
            className="w-4 h-4 accent-[#0099FE]"
          />
          <span className="text-[14px] text-gray-400">
            Don&apos;t show me again
          </span>
        </label>
      </main>
    </ModalCard>
  );
}
